module.exports = __webpack_public_path__ + "img/question-square.9e17c629.svg";